import { render, staticRenderFns } from "./OrgMainDashBoard.vue?vue&type=template&id=55ff0c43&scoped=true&"
import script from "./OrgMainDashBoard.vue?vue&type=script&lang=js&"
export * from "./OrgMainDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff0c43",
  null
  
)

export default component.exports